
import Event = createjs.Event;

export class Poker2SitnGoDataEvent extends Event {
    public static CHANGE_SITNGO_DATA: string = "changeSitnGoData";
    public static REGISTER_SITNGO: string = "registerSitnGo";
    public static UNREGISTER_SITNGO: string = "unRegisterSitnGo";
    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
